export default "__VITE_ASSET__DlgugHGn__"